
interface ScoreComponents {
  technical: number;
  industry: number;
  leadership: number;
  communication: number;
  growth: number;
}

export const calculateLoadedScore = (scores: ScoreComponents): number => {
  console.log("Calculating total score from components:", scores);
  
  // Map the legacy component names to the new Product Leadership Score categories
  const mappedScores = {
    productCraft: scores.technical,
    customerDiscovery: scores.communication,
    researchDesign: Math.round((scores.technical + scores.communication) / 2),
    marketImpact: scores.growth,
    productOperations: scores.leadership,
    industryImpact: scores.industry
  };
  
  // Apply max caps per category
  const cappedScores = {
    productCraft: Math.min(mappedScores.productCraft, 30),
    customerDiscovery: Math.min(mappedScores.customerDiscovery, 20),
    researchDesign: Math.min(mappedScores.researchDesign, 20),
    marketImpact: Math.min(mappedScores.marketImpact, 20),
    productOperations: Math.min(mappedScores.productOperations, 15),
    industryImpact: Math.min(mappedScores.industryImpact, 15)
  };
  
  console.log("Mapped to new Product Leadership scores:", cappedScores);
  
  // Calculate total score and cap at 120
  const total = Math.min(120, Object.values(cappedScores).reduce((sum, score) => sum + score, 0));
  console.log("Final calculated score (capped at 120):", total);
  
  return total;
};

export const getMaxScores = () => ({
  productCraft: 30,
  customerDiscovery: 20,
  researchDesign: 20,
  marketImpact: 20,
  productOperations: 15,
  industryImpact: 15
});
